import { Container, ModelGallery, SectionTitle } from '@sloyd/ui';
import { Wrapper } from './ContentAssetPacks.style';

export type ContentAssetPacksProps = {
  assetPacks: IAssetPack[];
  isLoading: boolean;
  callbacks: {
    onClick: (item: IAssetPack) => void;
  };
};

const COLUMN_COUNT = Math.floor(window.innerWidth / 250);

export function ContentAssetPacks(props: ContentAssetPacksProps) {
  const { assetPacks, isLoading, callbacks } = props;

  return (
    <Wrapper className='ContentAssetPacks-wrapper' data-testid='ContentAssetPacks-wrapper'>
      <SectionTitle gradient={{ from: '#e94057', to: '#f27121' }} title='📦 Examples'>
        Browse and download high-quality <strong>asset packs</strong>.
      </SectionTitle>
      <Container size='xl'>
        <ModelGallery
          isLoading={isLoading}
          cols={COLUMN_COUNT}
          baseImageUrl={''}
          items={assetPacks}
          personal
          containImage={false}
          onClick={callbacks.onClick}
        />
      </Container>
    </Wrapper>
  );
}

export default ContentAssetPacks;
